import * as React from "react"
import { FC, useEffect, useState } from "react"
import { Link } from "gatsby"
import axios from "axios"


interface SaRecommendPostEditor {
  UserID : number
}

interface SaAuthor {
  name? : string,
  slug? :  string,
  avatar_urls? : Array<string>
}

// customUserID: number
export const SaRecommendPostEditor : FC<SaRecommendPostEditor>  = (props) => {

  const UserID = props.UserID

  const [repo, setRepo] = useState<SaAuthor>({})
  const [src, setsrc] = useState<string>('')



  useEffect( () => {
    if (repo.avatar_urls) {
      setsrc(repo.avatar_urls[96])
    }
  },[repo] )

  useEffect( () => {
    if (UserID > 0){
      axios.get('https://dev-furlough.pantheonsite.io/wp-json/wp/v2/users/'+UserID)
        .then(function (response) {
          // handle success
          const myRepo = response.data
          setRepo(myRepo)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
    }
  },[] )



  return (
    <div className="article-info__main-analyst mb-3">
      <div className="">
        <Link to={`/contributor/${repo.slug}`} style={{width:"95px", display:"block"}}>
          <img style={{width:"86px"}} className="img-fluid mb-0" src={src} alt=""  />
        </Link>
      </div>
      <div className="mt-1">
        <Link to={`/contributor/${repo.slug}`} className="article-info__analyst-link">{repo.name}</Link>
      </div>
      <div className="article-info__analyst-job mt-1">{/*
        {repo.moreInformation.userLocation}
        {repo.moreInformation.userLocation && <br />}*/}
        <Link to={`/contributor/${repo.slug}`}>Editor</Link>
      </div>
    </div>
  )

}